<template>

  <v-hover v-slot:default="{ hover }">
    <v-card :class="{'ma-3': true, 'hover': hover}" outlined @click="$emit('edit')">
      <v-card-text>
        <v-row dense align="center">
          <v-col cols="3">
            <v-row no-gutters>
              <v-col cols="12">
                <small>Id: </small><strong>{{order.id}}</strong>
              </v-col>
              <v-col cols="12">
                <small>Sursa: </small><strong>{{order.source}}</strong>
              </v-col>
              <v-col cols="12">
                <small>Canal: </small><strong>{{order.channel}}</strong>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="3">
            <v-row no-gutters>
              <v-col cols="12">
                <small>Nume: </small>
                <strong>{{order.customer.first_name}} {{order.customer.last_name}}</strong>
              </v-col>
              <v-col cols="12">
                <small>Email: </small>
                <strong>{{order.customer.email}}</strong>
              </v-col>
              <v-col cols="12">
                <small>Telefon: </small>
                <strong>{{order.customer.phone}}</strong>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="3">
            <small>Total: </small><strong>{{order.total_price}} {{order.currency}}</strong>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-hover>

</template>


<script>

  export default {
    props: {
      order: null
    },

    data: () => ({
      hover: false
    })

  }

</script>


<style scoped>

  .hover {
    cursor: pointer;
    background-color: rgba(0, 0, 0, .05);
  }

</style>